import { Store } from './store';

export const selectAppInitLoading = (state: Store) => state.appInitLoading;

export const selectBenefitCategories = (state: Store) => state.benefitCategories ?? [];

export const selectBenefits = (state: Store) => state.benefits ?? [];

export const selectCountries = (state: Store) => state.countries ?? [];

export const selectCurrencies = (state: Store) => state.currencies ?? [];

export const selectEmirates = (state: Store) => state.emirates ?? [];

export const selectFacilityTypes = (state: Store) => state.facilityTypes ?? [];

export const selectGenders = (state: Store) => state.genders ?? [];

export const selectInsuranceCompanies = (state: Store) => state.insuranceCompanies ?? [];

export const selectMaritalStatuses = (state: Store) => state.maritalStatuses ?? [];

export const selectNetworkGroups = (state: Store) => state.networkGroups ?? [];

export const selectPaymentConfig = (state: Store) => state.paymentConfig ?? [];

export const selectPlanExclusions = (state: Store) => state.planExclusions ?? [];

export const selectPlans = (state: Store) => state.plans ?? [];

export const selectPlanTypes = (state: Store) => state.planTypes ?? [];

export const selectPolicyTypes = (state: Store) => state.policyTypes ?? [];

export const selectRelationships = (state: Store) => state.relationships ?? [];

export const selectSalaryBands = (state: Store) => state.salaryBands ?? [];

export const selectUserAcknowledgements = (state: Store) => state.userAcknowledgements ?? [];

export const selectUserAcknowledgementTypes = (state: Store) => state.userAcknowledgementTypes;

export const selectVatConfigurations = (state: Store) => state.vatConfigurations ?? [];

export const selectSystemConfigurationSettings = (state: Store) => state.systemConfigurationSettings;

export const selectSetAppInit = (state: Store) => state.setAppInit;

export const selectSetAppInitLoading = (state: Store) => state.setAppInitLoading;

export const selectPlanDocumentMappings = (state: Store) => state.planDocumentMappings ?? [];

export const selectOccupations = (state: Store) => state.occupations ?? [];

export const selectSponsorOccupations = (state: Store) => state.sponsorOccupations ?? [];

export const selectPlanCategories = (state: Store) => state.planCategorys ?? [];
